import React, { createContext, useCallback, useContext, useMemo } from 'react';
import { useCropperDispatch, actions, stateKeys } from '../../model';
import { getError } from '../../utils/getError';
import { useValueRef } from '../../utils/valueRef';
import { fileDataHandler } from '../commonUtils';

const { setErr } = actions;

const StateContext = createContext();
const ActionsContext = createContext();

export const useUploadState = () => useContext(StateContext);
export const useUploadActions = () => useContext(ActionsContext);

const Provider = ({ uploadContent, limits, accept, children }) => {
  const dispatch = useCropperDispatch();

  const limitsRef = useValueRef(limits);

  const onUpload = useCallback(async (file) => {
    const errMsgs = await getError({ file, limits: limitsRef.current });

    if (errMsgs.length > 0) {
      dispatch(setErr(errMsgs));
      return;
    }

    fileDataHandler(
      {
        [stateKeys.file]: file,
        [stateKeys.zoom]: 1,
        [stateKeys.initialCroppedArea]: null,
      },
      dispatch
    );
  }, []);

  const state = useMemo(
    () => ({ content: uploadContent, accept }),
    [uploadContent]
  );
  const actions = useMemo(() => ({ onUpload }), [onUpload]);

  return (
    <StateContext.Provider value={state}>
      <ActionsContext.Provider value={actions}>
        {children}
      </ActionsContext.Provider>
    </StateContext.Provider>
  );
};

export default Provider;
